import React, { useState } from 'react';

import { gql } from '@apollo/client';
import { useTranslation } from '@modernloop/i18n';
import { FCWithFragments, FilterListPopover } from '@modernloop/shared/components';
import { Avatar, Button } from '@mui/material';

import { BrighthireSelect_InterviewGuideFragment } from 'src/generated/mloop-graphql';

import { groupBy, renderGroup, useBrighthireFormOptions } from './useBrighthireFormOptions';

type Props = {
  jobId: string;
  onUpdated: (guide: BrighthireSelect_InterviewGuideFragment) => void;
};

type Fragments = {
  interviewGuide: BrighthireSelect_InterviewGuideFragment | undefined | null;
};

export const BrighthireButtonSelect: FCWithFragments<Fragments, Props> = ({ jobId, interviewGuide, onUpdated }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { brighthireEnabled, options, loading } = useBrighthireFormOptions({ jobId });

  if (!brighthireEnabled) {
    return null;
  }

  return (
    <FilterListPopover
      open={open}
      loading={loading}
      placeholderText={t('hiring-dashboard-common:common.select.searchGuides')}
      onPopoverClose={() => setOpen(false)}
      getOptionLabel={(option) => option.name}
      groupBy={(option) => groupBy(jobId, option)}
      renderGroup={renderGroup}
      options={options}
      PaperProps={{
        sx: {
          width: '400px',
        },
      }}
      getListHeight={() => 300}
      onChange={(_event, value) => {
        if (value.length !== 0) {
          onUpdated(value[value.length - 1]);
          setOpen(false);
        }
      }}
    >
      <Button
        startIcon={<Avatar src="/static/images/integrations/brighthire.png" />}
        size="small"
        onClick={() => {
          setOpen(true);
        }}
      >
        {interviewGuide?.name || t('hiring-dashboard-common:common.select.noInterviewGuide')}
      </Button>
    </FilterListPopover>
  );
};

BrighthireButtonSelect.fragments = {
  interviewGuide: gql`
    fragment BrighthireButtonSelect_interviewGuide on InterviewGuide {
      id
      name
    }
  `,
};
